import UseInnerWidth from "hooks/UseInnerWidth";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

function ChallengeTabs({ page }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const width = UseInnerWidth();
  const [selectedTab, setSelectedTab] = useState(page);
  const data = [
    { label: "Challenge Overview", labelSmall: "Overview", value: "overview" },
    { label: "Challenge Rules", labelSmall:"Rules", value: "rules" },
    { label: "Performance Overview", labelSmall:"Performance" ,value: "performance" },
    { label: "Trades",labelSmall: "Trades", value: "trades" },
  ];


  return (
    <div className="flex  flex-row sm:items-center sm:gap-16 gap-6 border-border-darkNew border-b  mb-4 sm:justify-start justify-between">
      {data.map((tab, index) => (
        <div
          key={index}
          className={`text-base   ${
            tab?.value === "disabled"
              ? "text-fade opacity-25 cursor-not-allowed"
              : tab?.value === selectedTab
              ? "border-primary  cursor-pointer text-primary"
              : "text-text-secondary border-transparent cursor-pointer text-white-opacity font-N_Roman "
          }  pb-1 border-b-[3px]  whitespace-nowrap`}
          onClick={() =>
            tab?.value != "disabled" &&
            navigate(`/challenge/${id}/${tab?.value}`)
          }
        >
          {width > 650 ? tab?.label : tab?.labelSmall}
        </div>
      ))}
    </div>
  );
}

export default ChallengeTabs;
